<template>
  <div class="font-italic">
    <div>
      <!-- I've taken this seemingly overcomplicated approach to make sure Safari doesn't clip the quotation marks when they're italicized -->
      <div class="before" />
      <span class="preserve-newlines" v-html="text" />
      <div class="after" />
    </div>
    <div class="my-3 d-flex flex-grow-1">
      <div class="flex-grow-0 my-3">–</div>
      <div class="flex-grow-1 d-sm-flex align-end">
        <div class="flex-grow-1 ma-3 mb-2">
          {{name}}
          <div class="text--label-active">
            {{role}}<template v-if="role && company">, </template>{{company}}
          </div>
        </div>
        <div class="flex-grow-0 text-right mb-2 mx-n2">
          <v-btn
            class="d-inline-flex align-center pa-2"
            style="height: 40px; min-width: unset;"
            large text
            v-bind="link ? { target: '_blank', href: link } : {}"
          >
            <img v-if="src == 'Capterra'" height="24" loading="lazy" src="../assets/capterra.svg" />
            <img v-else-if="src == 'Google'" height="24" loading="lazy" src="../assets/g-logo.png" />
            <img v-else-if="src == 'Trustpilot'" height="24" loading="lazy" src="../assets/trustpilot-dark.svg" />
            <!-- <img v-else height="36" src="/ellacard-logo-filled-307x160.png" /> -->
            <template v-if="src">
              <v-icon class="ml-3" color="primary" v-html="mdiOpenInNew" />
              <span class="btn-tooltip bottom left">Full review by {{name}} on {{src}}</span>
            </template>
            <!-- <span v-else class="btn-tooltip bottom left">Feedback shared directly with Ellacard</span> -->
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>


<style scoped lang="scss">
.before, .after {
  display: inline-block;
  position: relative;
  opacity: .5;
  width: 36px;
}

.before::before, .after::before {
  position: absolute;
  font-size: 5em;
  width: 60px;
}

.before::before {
  content: '“';
  bottom: -.92em;
  left: -.18em;
}

.after::before {
  content: '”';
  top: -.52em;
  left: -.12em;
}
</style>


<script>
import { mdiEmail, mdiOpenInNew } from '@mdi/js';

export default {
  name: 'quote-card',

  props: [ 'text', 'name', 'company', 'role', 'src', 'link' ],

  created() {
    Object.assign(this, { mdiEmail, mdiOpenInNew });
  }
}
</script>
